import { getSrcs } from '@helpers/image';
import { Device, until } from '@helpers/media';
import CtaLink from '@stories/Components/Buttons/CtaLink/CtaLink';
import LinkButton from '@stories/Components/Buttons/LinkButton/LinkButton';
import * as React from 'react';
import S from './CtaCard.styles';
import { linkAria } from '@helpers/utils';
const CtaCard = (props) => {
    const srcs = props.image
        ? getSrcs(props.image, 730, 375, 5, 576 / (props.imageShape === 'curved' ? 427 : 353))
        : [];
    const sizes = `${until(Device.Tablet)} calc(100vw - var(--sitePadding) * 2)), ${until(Device.TabletLarge)} calc(50vw - var(--sitePadding) * 2)), ${until(Device.DesktopSmall)} calc(33vw - (var(--sitePadding) * 2)), ${until(Device.DesktopLarge)} calc(25vw - (var(--sitePadding) * 2)), 428px`;
    return (React.createElement(S.Container, { "data-image-shape": props.imageShape ?? 'rectangle', ...(props.tag
            ? {
                style: {
                    '--tagColor': props.tag.bgColor,
                    '--tagFgColor': props.tag.fgColor,
                },
            }
            : {}) },
        props.image && (React.createElement(S.ImageWrapper, null,
            React.createElement(S.Img, { src: srcs[0].split(' ')[0], srcSet: srcs.join(','), sizes: sizes, alt: props.image.altText ?? props.title, loading: 'lazy' }))),
        React.createElement(S.ContentWrapper, null,
            React.createElement(S.ContentArea, null,
                props.tag && (React.createElement(S.TagArea, null,
                    React.createElement(S.Tag, null, props.tag.text))),
                React.createElement(S.Title, null, props.title),
                props.content && React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: props.content } })),
            props.cta && props.cta.url && (React.createElement(S.CtaArea, null,
                props.buttonStyle === 'text-link' && (React.createElement(CtaLink, { "aria-label": linkAria(props.cta.text ?? '', props.cta.target, props.translations && props.translations['lcci.link.newtab']), href: props.cta.url, target: props.cta.target, icon: props.cta.target === '_blank' ? 'external' : undefined }, props.cta.text ?? 'Read More')),
                props.buttonStyle === 'pill' && (React.createElement(LinkButton, { buttonType: "blue-outline", "aria-label": linkAria(props.cta.text ?? '', props.cta.target, props.translations && props.translations['lcci.link.newtab']), href: props.cta.url, target: props.cta.target }, props.cta.text ?? 'Read More')))))));
};
export default CtaCard;
